import React from "react";
import { Link } from "react-router-dom";
import { Logomark } from "./Navbar";

const cols = [
  {
    title: "Product",
    links: [
      ["DMARC", "/product"],
      ["SPF Optimization", "/product"],
      ["Sender Discovery", "/product"],
      ["Threat Detection", "/product"],
      ["BIMI Readiness", "/product"],
    ],
  },
  {
    title: "Platform",
    links: [
      ["Architecture", "/architecture"],
      ["Security", "/security"],
      ["MSP", "/msp"],
      ["Developers", "/developers"],
      ["Docs", "/docs"],
    ],
  },
  {
    title: "Company",
    links: [
      ["Pricing", "/pricing"],
      ["Trust Center", "/security"],
      ["Changelog", "/docs"],
      ["Status", "/architecture"],
    ],
  },
];

export default function Footer() {
  return (
    <footer className="border-t border-stone-200 mt-32 bg-[#FBF9F4]" data-testid="marketing-footer">
      <div className="max-w-7xl mx-auto px-6 py-20 grid grid-cols-2 md:grid-cols-5 gap-12">
        <div className="col-span-2">
          <div className="flex items-center gap-2.5 mb-5">
            <Logomark />
            <div className="font-display font-bold tracking-tight ink">TrustDmarc</div>
          </div>
          <p className="text-sm ink-soft max-w-xs leading-relaxed">
            Email trust intelligence for modern domains. Only verified domains. No blind trust.
          </p>
        </div>
        {cols.map((c) => (
          <div key={c.title}>
            <div className="text-xs font-semibold uppercase tracking-wider ink-soft mb-4">{c.title}</div>
            <ul className="space-y-3">
              {c.links.map(([label, to]) => (
                <li key={label}>
                  <Link to={to} className="text-sm text-stone-700 hover:ink transition-colors">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-stone-200 py-6">
        <div className="max-w-7xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="text-xs ink-muted">© 2026 TrustDmarc Labs · Edge-native email trust</div>
          <div className="flex items-center gap-2 text-xs ink-soft">
            <span className="pulse-dot"></span>
            All systems operational
          </div>
        </div>
      </div>
    </footer>
  );
}
